module.exports = __webpack_public_path__ + "img/home_bihuan.0a2ea797.png";